import { render, staticRenderFns } from "./history.vue?vue&type=template&id=bc22357c&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=bc22357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc22357c",
  null
  
)

export default component.exports